import React from 'react';
import EVAverageGraph, {EVAverageGraphType} from '@di-shared/features/home/kr/ev-battery/EVAverageGraph';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {GetEvBatteryManagementTripResponse} from '@di-shared/api/di/__generated';
import harshDrivingRateStatus = GetEvBatteryManagementTripResponse.harshDrivingRateStatus;

interface AccelerationRatioProps {
  user: AccelerationCount;
  avgCustomer: AccelerationCount;
  harshDrivingRateStatus: harshDrivingRateStatus;
}

interface AccelerationCount {
  accelerationDrivingCount: number;
  normalDrivingCount: number;
}

function getDescKey(accelerationRatioType: harshDrivingRateStatus) {
  switch (accelerationRatioType) {
    case harshDrivingRateStatus.LOW:
      return 'T30412';
    case harshDrivingRateStatus.MEDIUM:
      return 'T30413';
    case harshDrivingRateStatus.HIGH:
      return 'T30414';
  }
}

function AccelerationRatio({user, avgCustomer, harshDrivingRateStatus}: AccelerationRatioProps) {
  const {t} = useInferableTranslation();
  return (
    <EVAverageGraph
      title={t('T30404')}
      desc={t(getDescKey(harshDrivingRateStatus))}
    >
      <EVAverageGraph.BarGraph
        filledAreaRatio={user.accelerationDrivingCount / (user.normalDrivingCount + user.accelerationDrivingCount)}
        dashedAreaRatio={avgCustomer.accelerationDrivingCount / (avgCustomer.normalDrivingCount + avgCustomer.accelerationDrivingCount)}
        graphType={EVAverageGraphType.TYPE_ACCELERATION}
        Tags={[
          {
            title: t('T30482'),
            count: user.normalDrivingCount,
          },
          {
            title: t('T30417'),
            count: user.accelerationDrivingCount,
            type: EVAverageGraphType.TYPE_ACCELERATION,
          },
        ]}
      />
    </EVAverageGraph>
  );
}

export default AccelerationRatio;
